var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{class:{
        sortable: _vm.column.isSortable,
        'asc': _vm.sortASC,
        'desc': _vm.sortDESC
    },style:(_vm.columnStyle),attrs:{"rowspan":_vm.rowspan,"colspan":_vm.colspan},domProps:{"innerHTML":_vm._s(_vm.columnContent)},on:{"click":function($event){$event.preventDefault();return _vm.sort.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }